/**
 * Variant definitions for the shared nutrition calculator.
 *
 * `NutritionApp.tsx` holds the whole implementation; every registered app is just
 * a thin wrapper that binds one of these variants. A variant is what makes two
 * apps that share code point at *different* AppConfig rows (`appKey`), so each
 * hospital can configure its formulas per app.
 */
/**
 * Which TPN tab opens first.
 * - `nutrition` — "חישוב ערכים תזונתיים": enter a rate per hour, read the nutritional values.
 * - `rate` — "חישוב קצב": enter a target amount per kg, read the rate you need to give.
 */
export type TpnMode = 'nutrition' | 'rate';

export interface NutritionVariant {
    /** AppConfig `appName` — also the `App.key` used for admin permissions. */
    appKey: string;
    /** AppConfig `configName`. */
    configName: string;
    /** Hebrew title shown in the app header. */
    title: string;
    /** Extra root class so a variant can be styled differently if ever needed. */
    rootClass: string;
    /** Prefix used when naming the exported PDF file. */
    pdfFileNamePrefix: string;
    /** TPN tab selected when the app opens. */
    defaultTpnMode: TpnMode;
}

export const PREEMIE_NUTRITION_VARIANT: NutritionVariant = {
    appKey: 'PREEMIE_NUTRITION',
    configName: 'nutrition-values',
    title: 'תזונת פגים',
    rootClass: 'preemie-nutrition-variant',
    pdfFileNamePrefix: 'תזונת-פגים',
    defaultTpnMode: 'nutrition',
};

export const NICU_NUTRITION_VARIANT: NutritionVariant = {
    appKey: 'NICU_NUTRITION',
    configName: 'nutrition-values',
    title: 'הזנה בטיפול נמרץ ילדים',
    rootClass: 'nicu-nutrition-variant',
    pdfFileNamePrefix: 'הזנה-טיפול-נמרץ-ילדים',
    defaultTpnMode: 'rate',
};
